export default "__VITE_ASSET__BUz05bQ0__"